import { render, staticRenderFns } from "./HeaderAccount.vue?vue&type=template&id=020a0038&scoped=true&"
import script from "./HeaderAccount.vue?vue&type=script&lang=js&"
export * from "./HeaderAccount.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAccount.vue?vue&type=style&index=0&id=020a0038&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a0038",
  null
  
)

export default component.exports